import React, { Suspense, useEffect, useMemo, useState } from "react";
import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";
import { getHashRoute } from "./routes/hashRouting";

const PostsPage = React.lazy(() => import("./pages/PostsPage"));
const PostViewPage = React.lazy(() => import("./pages/PostViewPage"));
const AdminPage = React.lazy(() => import("./pages/AdminPage"));

function RouteFallback() {
  return (
    <div className="container">
      <div className="loading">Loading…</div>
    </div>
  );
}

export default function App() {
  const isStandalone = window.location.hostname.startsWith("tool.") || window.location.hostname.startsWith("tools.") || window.location.hostname.includes(".tool.") || window.location.hostname.includes(".tools.") || new URLSearchParams(window.location.search).get("standalone") === "true";

  const getRoute = () => {
    const pathname = window.location.pathname || "/";
    if (pathname === "/manage" || pathname.startsWith("/manage/")) {
      return { name: "manage" };
    }
    return getHashRoute(window.location.hash);
  };

  const [route, setRoute] = useState(() => getRoute());

  useEffect(() => {
    const onChange = () => setRoute(getRoute());
    window.addEventListener("hashchange", onChange);
    window.addEventListener("popstate", onChange);
    return () => {
      window.removeEventListener("hashchange", onChange);
      window.removeEventListener("popstate", onChange);
    };
  }, []);

  const title = useMemo(() => {
    if (route.name === "guides") return "Guides";
    if (route.name === "tools") return "Tools";
    if (route.name === "updates") return "Updates";
    if (route.name === "manage") return "Manage";
    if (route.name === "post") return "Post";
    return "Home";
  }, [route.name]);

  useEffect(() => {
    document.title = `${title} · Calculateyourtax.in`;
  }, [title]);

  const content = (() => {
    if (route.name === "home") return <HomePage section={route.section} />;
    if (route.name === "guides") return <PostsPage section="guides" />;
    if (route.name === "tools") return <PostsPage section="tools" />;
    if (route.name === "updates") return <PostsPage section="updates" />;
    if (route.name === "post") return <PostViewPage postId={route.postId} />;
    if (route.name === "manage") return <AdminPage />;
    return <HomePage section={undefined} />;
  })();

  if (isStandalone) {
    return (
      <div className="site standalone">
        <main className="site-main">
          <Suspense fallback={<RouteFallback />}>{content}</Suspense>
        </main>
      </div>
    );
  }

  if (route.name === "manage") {
    return (
      <div className="site">
        <main className="site-main">
          <Suspense fallback={<RouteFallback />}>{content}</Suspense>
        </main>
      </div>
    );
  }

  return (
    <div className="site">
      <Header routeName={route.name} />
      <main className="site-main">
        <Suspense fallback={<RouteFallback />}>{content}</Suspense>
      </main>
      <Footer />
    </div>
  );
}
